import * as React from 'react';
import {
  actionsMenuLayoutDriverFactory,
  ActionsMenuLayoutDriver,
} from './ActionsMenuLayout.driver';
import { ActionsMenuLayout } from '.';
import { KEYS } from '../../common/keyCodes';
import {
  TPAComponentsWrapper,
  createRendererWithUniDriver,
} from '../../test/utils';

describe('ActionsMenuLayout', () => {
  const render = createRendererWithUniDriver<ActionsMenuLayoutDriver>(
    actionsMenuLayoutDriverFactory,
  );

  const baseProps = {
    'data-hook': 'data-hook',
  };

  it('should render', async () => {
    const { driver } = render(
      <ActionsMenuLayout {...baseProps}>
        <ActionsMenuLayout.Item onClick={() => {}} content="test" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );
    expect(await driver.exists()).toBe(true);
  });

  it('should not focus first element if focusedIndex is not provided', async function () {
    const { driver } = render(
      <ActionsMenuLayout {...baseProps}>
        <ActionsMenuLayout.Item onClick={() => {}} content="test" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );

    const item = await driver.item('test').getNative();
    expect(document.activeElement).not.toEqual(item);
  });
  it('should focus 1st element if focusedIndex=0', async function () {
    const { driver } = render(
      <ActionsMenuLayout {...baseProps} focusedIndex={0}>
        <ActionsMenuLayout.Item onClick={() => {}} content="test1" />
        <ActionsMenuLayout.Item onClick={() => {}} content="test2" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );

    const item = await driver.item('test1').getNative();

    expect(document.activeElement).toEqual(item);
  });

  it('should focus 2nd element if focusedIndex=1', async function () {
    const { driver } = render(
      <ActionsMenuLayout {...baseProps} focusedIndex={1}>
        <ActionsMenuLayout.Item onClick={() => {}} content="test1" />
        <ActionsMenuLayout.Item onClick={() => {}} content="test2" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );

    const item = await driver.item('test2').getNative();

    expect(document.activeElement).toEqual(item);
  });

  it('should trigger onClick', async function () {
    const onClick = jest.fn();
    const { driver } = render(
      <ActionsMenuLayout {...baseProps}>
        <ActionsMenuLayout.Item onClick={onClick} content="test" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );

    await driver.clickItem('test');
    expect(onClick).toHaveBeenCalled();
  });

  it('should navigate by keyboard keys', async function () {
    const { driver } = render(
      <ActionsMenuLayout {...baseProps} focusedIndex={1}>
        <ActionsMenuLayout.Item onClick={() => {}} content="test1" />
        <ActionsMenuLayout.Item onClick={() => {}} content="test2" />
        <ActionsMenuLayout.Item onClick={() => {}} content="test3" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );

    const layout = driver.layout();
    const item1 = await driver.item('test1').getNative();
    const item2 = await driver.item('test2').getNative();
    const item3 = await driver.item('test3').getNative();

    expect(document.activeElement).toEqual(item2);

    await layout.pressKey(KEYS.ArrowDown);

    expect(document.activeElement).toEqual(item3);
    await layout.pressKey(KEYS.ArrowDown);

    expect(document.activeElement).toEqual(item1);

    await layout.pressKey(KEYS.ArrowUp);
    expect(document.activeElement).toEqual(item3);
  });

  it('should fire onClick on space and enter keys', async function () {
    const onClick = jest.fn();

    const { driver } = render(
      <ActionsMenuLayout {...baseProps}>
        <ActionsMenuLayout.Item onClick={onClick} content="test1" />
      </ActionsMenuLayout>,
      baseProps['data-hook'],
    );

    const item = driver.item('test1');

    await item.pressKey(KEYS.Spacebar);
    await item.pressKey(KEYS.Enter);

    expect(onClick).toHaveBeenCalledTimes(2);
  });

  it('should use mobile design', async () => {
    const { driver } = render(
      TPAComponentsWrapper({ mobile: true })(
        <ActionsMenuLayout {...baseProps}>
          <ActionsMenuLayout.Item onClick={() => {}} content="test" />
        </ActionsMenuLayout>,
      ),
      baseProps['data-hook'],
    );
    expect(await driver.isMobile()).toBe(true);
  });
});
